import { render, staticRenderFns } from "./institutionDetail.vue?vue&type=template&id=ad853fba&scoped=true"
import script from "./institutionDetail.vue?vue&type=script&lang=js"
export * from "./institutionDetail.vue?vue&type=script&lang=js"
import style0 from "./institutionDetail.vue?vue&type=style&index=0&id=ad853fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad853fba",
  null
  
)

export default component.exports